import Envelope from "../utils/Envelope";
import _ from 'lodash';
import GroupModel from "../diagrams/Group/GroupModel";

export default class PluginLayout {

    constructor(designer, {
    } = {}) {

        this.designer = designer;
    }

    install() {

    }

    uninstall() {

    }

    ungroupItems(items) {

        if (!items || items.length === 0)
            return;

        items = [...items];
        const parent = items[0]._sys.parent;
        items.forEach(c => {
            if (c._sys.parent !== parent)
                throw new Error("无法将不同容器内的部件同时取消组合");
        });

        let models = [];
        items.forEach(c => {
            let res = this.ungroupItem(c);
            let rres = [];
            res.forEach(d => {
                if (items.indexOf(d) < 0)
                    rres.push(d);
            })

            models = [...models, ...rres];
        });

        this.designer.selectedItems = models;
        this.designer.properties.needSave = true;
    }

    ungroupItem(item) {

        if (item.getType() !== "GroupModel")
            return [];

        if (item._sys.parent)
            item._sys.parent.deleteModel(item, false);
        else
            this.designer.deleteModel(item, false);

        let { x, y, margin } = item;
        const models = [...item.diagrams];

        models.forEach(c => {
            c.x += (x + margin);
            c.y += (y + margin);
            item.deleteModel(c, false);

            if (item._sys.parent)
                item._sys.parent.addModel(c, false);
            else
                this.designer.addModel(c, false, false);
        });

        if (item._sys.parent)
            item._sys.parent.diagrams = [...item._sys.parent.diagrams];

        return models;
    }

    groupItems(items) {

        if (!items || items.length <= 1)
            return;

        items = [...items];
        const parent = items[0]._sys.parent;
        items.forEach(c => {
            if (c._sys.parent !== parent)
                throw new Error("无法将不同容器内的部件组合在一起");
        });

        const ext = new Envelope({
            left: items[0].x,
            top: items[0].y,
            width: items[0].width * items[0].scale,
            height: items[0].height * items[0].scale,
        });

        items.forEach(c => {
            ext.unionByXY(c.x, c.y);
            ext.unionByXY(c.x + c.width * c.scale, c.y + c.height * c.scale);
        });

        ext.bufferByPercent(.1);

        const m = new GroupModel({
            x: Math.floor(ext.left),
            y: Math.floor(ext.top),
            width: Math.ceil(ext.width),
            height: Math.ceil(ext.height),
        });

        if (!parent) {
            this.designer.deleteModels(items, false);
        }
        else {
            parent.deleteModels(items, false);
        }

        items.forEach(c => {
            c.x -= m.x;
            c.y -= m.y;
            m.addModel(c);
        });

        if (!parent) {
            this.designer.addModel(m, true);
        }
        else {
            parent.addModel(m, true);
            this.designer.selectedItems = m;
        }

        this.designer.properties.needSave = true;
    }

    levelItems(direction) {

        const items = this.designer.selectedItems.filter(c => c !== this.designer.paper);
        if (items.length === 0)
            return;

        const parent = items[0]._sys.parent;
        items.forEach(c => {
            if (c._sys.parent !== parent)
                throw new Error("无法对不同容器内的部件同时进行层级排列");
        });

        if (direction === "top") {
            this.levelTop();
        }
        else if (direction === "up") {
            this.levelUp();
        }
        else if (direction === "bottom") {
            this.levelBottom();
        }
        else if (direction === "down") {
            this.levelDown();
        }
    }

    getExtent(items) {

        let env = new Envelope({
            left: items[0].x,
            top: items[0].y,
            width: items[0].width,
            height: items[0].height
        });

        items.forEach(c => {
            env.unionByXY(c.x, c.y);
            env.unionByXY(c.x + c.width, c.y + c.height);
        });

        return env;
    }

    levelTop() {

        const items = this.designer.selectedItems.filter(c => c !== this.designer.paper);
        if (items.length === 0)
            return;

        const extent = this.getExtent(items);
        let diagrams = items[0]._sys.parent ? items[0]._sys.parent.diagrams : this.designer.diagrams;
        const interItems = diagrams.filter(c => items.indexOf(c) < 0 && c.localIntersectsByRectangle(extent.left, extent.top, extent.width, extent.height));
        if (interItems.length === 0)
            return;

        const maxItem = _.maxBy(interItems, c => c.zIndex);
        const maxZ = maxItem ? maxItem.zIndex : -1;

        items.forEach(c => c.zIndex += maxZ + 1);
    }

    levelUp() {

        let items = this.designer.selectedItems.filter(c => c !== this.designer.paper);
        if (items.length === 0)
            return;

        const extent = this.getExtent(items);
        let diagrams = items[0]._sys.parent ? items[0]._sys.parent.diagrams : this.designer.diagrams;
        let interItems = diagrams.filter(c => c.localIntersectsByRectangle(extent.left, extent.top, extent.width, extent.height));
        if (interItems.length === 0)
            return;

        items = _.orderBy(items, c => c.zIndex);
        interItems = _.orderBy(interItems, c => c.zIndex);
        for (let i = items.length - 1; i >= 0; i--) {
            const item = items[i];

            let index = interItems.indexOf(item);
            if (index < 0)
                continue;
            if (index >= interItems.length - 1)
                continue;

            const nextItem = interItems[index + 1];
            if (items.indexOf(nextItem) >= 0)
                continue;

            const dz = nextItem.zIndex + 1 - item.zIndex;
            item.zIndex = nextItem.zIndex + 1;

            for (let j = index + 2; j < interItems.length; j++) {
                const element = interItems[j];
                element.zIndex += dz;
            }

            interItems = _.orderBy(interItems, c => c.zIndex);
        }
    }

    levelBottom() {
        const items = this.designer.selectedItems.filter(c => c !== this.designer.paper);
        if (items.length === 0)
            return;

        const extent = this.getExtent(items);
        let diagrams = items[0]._sys.parent ? items[0]._sys.parent.diagrams : this.designer.diagrams;
        const interItems = diagrams.filter(c => items.indexOf(c) < 0 && c.localIntersectsByRectangle(extent.left, extent.top, extent.width, extent.height));
        if (interItems.length === 0)
            return;

        const maxItem = _.maxBy(items, c => c.zIndex);
        const maxZ = maxItem ? maxItem.zIndex : -1;

        interItems.forEach(c => c.zIndex += maxZ + 1);
    }

    levelDown() {

        let items = this.designer.selectedItems.filter(c => c !== this.designer.paper);
        if (items.length === 0)
            return;

        const extent = this.getExtent(items);
        let diagrams = items[0]._sys.parent ? items[0]._sys.parent.diagrams : this.designer.diagrams;
        let interItems = diagrams.filter(c => c.localIntersectsByRectangle(extent.left, extent.top, extent.width, extent.height));
        if (interItems.length === 0)
            return;

        items = _.orderBy(items, c => c.zIndex);
        interItems = _.orderBy(interItems, c => c.zIndex);
        for (let i = 0; i < items.length; i++) {
            const item = items[i];

            let index = interItems.indexOf(item);
            if (index <= 0)
                continue;
            if (index >= interItems.length)
                continue;

            const nextItem = interItems[index - 1];
            if (items.indexOf(nextItem) >= 0)
                continue;

            item.zIndex = nextItem.zIndex;
            nextItem.zIndex += 1;

            for (let j = index + 1; j < interItems.length; j++) {
                const element = interItems[j];
                element.zIndex += nextItem.zIndex;
            }

            interItems = _.orderBy(interItems, c => c.zIndex);
        }
    }

    findUp(item, selectedItems) {

        let items = [];
        let selfIndex = 99999999;
        for (let i = 0; i < this.designer.diagrams.length; i++) {
            const d = this.designer.diagrams[i];

            if (d === item) {
                selfIndex = i;
                continue;
            }
            if (selectedItems.indexOf(d) >= 0)
                continue;
            if (!d.intersectsByRectangle(item.x, item.y, item.width, item.height))
                continue;
            if (d.zIndex < item.zIndex)
                continue;
            if (d.zIndex === item.zIndex && i <= selfIndex)
                continue;

            items.push(d);
        }

        items = _.orderBy(items, c => c.zIndex);
        return items;
    }

    alignItems(direction) {

        const items = this.designer.selectedItems;
        if (!items || items.length <= 1)
            return;

        const parent = items[0]._sys.parent;
        items.forEach(c => {
            if (c._sys.parent !== parent)
                throw new Error("无法对不同容器内的部件进行排列");
        });

        if (direction === "left") {
            this.alignLeft();
        }
        else if (direction === "right") {
            this.alignRight();
        }
        else if (direction === "hcenter") {
            this.alignCenterH();
        }
        else if (direction === "top") {
            this.alignTop();
        }
        else if (direction === "bottom") {
            this.alignBottom();
        }
        else if (direction === "vcenter") {
            this.alignCenterV();
        }
        else if (direction === "edgeLeft") {
            this.alignEdgeLeft();
        }
        else if (direction === "edgeRight") {
            this.alignEdgeRight();
        }
        else if (direction === "edgeTop") {
            this.alignEdgeTop();
        }
        else if (direction === "edgeBottom") {
            this.alignEdgeBottom();
        }
    }

    alignLeft() {

        const items = this.designer.selectedItems;
        if (items.length <= 1)
            return;

        const x = items[0].x;
        for (let i = 1; i < items.length; i++) {
            const item = items[i];
            item.x = x;
        }
    }

    alignRight() {

        const items = this.designer.selectedItems;
        if (items.length <= 1)
            return;

        const right = items[0].x + items[0].width * items[0].scale;
        for (let i = 1; i < items.length; i++) {
            const item = items[i];
            item.x = right - item.width * item.scale;
        }
    }

    alignCenterH() {

        const items = this.designer.selectedItems;
        if (items.length <= 1)
            return;

        const center = items[0].x + items[0].width * items[0].scale / 2;
        for (let i = 1; i < items.length; i++) {
            const item = items[i];
            item.x = Math.round(center - item.width * item.scale / 2);
        }
    }

    alignTop() {

        const items = this.designer.selectedItems;
        if (items.length <= 1)
            return;

        const y = items[0].y;
        for (let i = 1; i < items.length; i++) {
            const item = items[i];
            item.y = y;
        }
    }

    alignBottom() {

        const items = this.designer.selectedItems;
        if (items.length <= 1)
            return;

        const bottom = items[0].y + items[0].height * items[0].scale;
        for (let i = 1; i < items.length; i++) {
            const item = items[i];
            item.y = bottom - item.height * item.scale;
        }
    }

    alignCenterV() {

        const items = this.designer.selectedItems;
        if (items.length <= 1)
            return;

        const center = items[0].y + items[0].height * items[0].scale / 2;
        for (let i = 1; i < items.length; i++) {
            const item = items[i];
            item.y = Math.round(center - item.height * item.scale / 2);
        }
    }

    alignEdgeLeft() {

        const items = this.designer.selectedItems;
        if (items.length <= 1)
            return;

        let x = items[0].x;
        for (let i = 1; i < items.length; i++) {
            const item = items[i];
            item.x = x - item.width * item.scale;
            x = item.x;
        }
    }

    alignEdgeRight() {

        const items = this.designer.selectedItems;
        if (items.length <= 1)
            return;

        let right = items[0].x + items[0].width * items[0].scale;
        for (let i = 1; i < items.length; i++) {
            const item = items[i];
            item.x = right;
            right = item.x + item.width * item.scale;
        }
    }

    alignEdgeTop() {

        const items = this.designer.selectedItems;
        if (items.length <= 1)
            return;

        let y = items[0].y;
        for (let i = 1; i < items.length; i++) {
            const item = items[i];
            item.y = y - item.height * item.scale;
            y = item.y;
        }
    }

    alignEdgeBottom() {

        const items = this.designer.selectedItems;
        if (items.length <= 1)
            return;

        let bottom = items[0].y + items[0].height * items[0].scale;
        for (let i = 1; i < items.length; i++) {
            const item = items[i];
            item.y = bottom;
            bottom = items[i].y + items[i].height * items[i].scale;
        }
    }
}